import React, { useEffect, useState } from "react";

const WA_NUMBER = "5491124289800";
const WA_MSG = encodeURIComponent(
  "Hola! Me comunico desde la web. Quisiera consultar disponibilidad."
);

const HERO_IMAGES = ["/images/herosection.webp"];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % HERO_IMAGES.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center overflow-hidden"
      aria-label="Inicio - Magic Kingdom Eventos"
    >
      {HERO_IMAGES.map((img, i) => (
        <div
          key={img}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === current ? 1 : 0 }}
        >
          <img
            src={img}
            alt={`Salon de fiestas infantiles Magic Kingdom Eventos en Quilmes - imagen ${i + 1}`}
            className="w-full h-full object-cover"
            loading={i === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-hero-gradient" />
      <div className="absolute top-0 left-0 right-0 h-1 bg-gold-gradient" />

      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-float"
            style={{
              left: `${12 + i * 14}%`,
              top: `${18 + (i % 3) * 24}%`,
              animationDelay: `${i * 0.5}s`,
              opacity: 0.55,
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path
                d="M10 0L12 8L20 10L12 12L10 20L8 12L0 10L8 8L10 0Z"
                fill="#F2C94C"
                opacity="0.85"
              />
            </svg>
          </div>
        ))}
      </div>

      <div className="relative z-10 w-full">
        <div className="container mx-auto px-6 py-20 lg:py-28">
          <div className="grid lg:grid-cols-[1.1fr_0.9fr] gap-12 items-center">
            <div className="text-white space-y-6 text-center lg:text-left">
              <div
                className={`inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full px-5 py-2 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                  }`}
              >
                <span className="w-2 h-2 rounded-full bg-gold-light animate-pulse" />
                <span className="font-body text-white/90 text-sm font-medium">
                  Mas de 25 años de experiencia
                </span>
              </div>

              <h1
                className={`font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white text-shadow leading-tight transition-all duration-700 delay-150 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                  }`}
              >
                Salon de fiestas infantiles en Quilmes
                <span className="block text-gold-light">Magic Kingdom Eventos</span>
              </h1>

              <p
                className={`font-body text-white/85 text-lg md:text-xl max-w-2xl lg:max-w-xl leading-relaxed text-shadow-sm transition-all duration-700 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                  }`}
              >
                Un espacio en Quilmes para cumpleaños infantiles, baby shower,
                comunion y eventos familiares con ambientacion, juego y momentos
                inolvidables.
              </p>

              <p
                className={`font-body text-white/75 text-base md:text-lg max-w-2xl lg:max-w-xl leading-relaxed text-shadow-sm transition-all duration-700 delay-[400ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                  }`}
              >
                Estamos en Felipe Amoedo 1660 y preparamos festejos con salon,
                animacion y servicios extra para que cada familia disfrute de verdad.
              </p>

              <div
                className={`flex flex-wrap gap-3 justify-center lg:justify-start transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                  }`}
              >
                <div className="flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
                  <span className="text-white text-sm font-medium">75 adultos</span>
                </div>

                <div className="flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
                  <span className="text-white text-sm font-medium">40 chicos</span>
                </div>

                <div className="flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
                  <span className="text-white text-sm font-medium">Quilmes, Buenos Aires</span>
                </div>

                <div className="flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
                  <span className="text-white text-sm font-medium">Salon con experiencia y calidez</span>
                </div>
              </div>

              <div
                className={`flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-2 transition-all duration-700 delay-[600ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                  }`}
              >
                <a
                  href={`https://wa.me/${WA_NUMBER}?text=${WA_MSG}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                  aria-label="Consultar disponibilidad por WhatsApp"
                >
                  Consultar por WhatsApp
                </a>

                <a
                  href="#salon"
                  className="btn-outline"
                  aria-label="Ver informacion del salon"
                >
                  Ver el salon
                </a>
              </div>
            </div>

            <div
              className={`relative hidden lg:block transition-all duration-700 delay-300 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
                }`}
            >
              <div className="relative mx-auto max-w-[520px]">
                <div className="absolute -top-10 -right-8 w-52 h-52 bg-gold/25 rounded-full blur-3xl" />
                <div className="absolute -bottom-14 -left-10 w-72 h-72 bg-primary/25 rounded-full blur-3xl" />

                <div className="relative z-10 rounded-[2rem] overflow-hidden shadow-2xl rotate-3 translate-y-6 hover:rotate-0 transition-transform duration-500 border border-white/20 bg-white/10 backdrop-blur-sm">
                  <img
                    style={{ maxHeight: "450px" }}
                    src="/images/castle.jpg"
                    alt="Magic Kingdom Eventos, salon infantil en Quilmes"
                    className="w-full h-auto object-cover"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs font-body">Desliza</span>
        <svg
          className="w-4 h-4 text-white/50"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>

      <div className="absolute bottom-16 left-1/2 -translate-x-1/2 flex gap-2">
        {HERO_IMAGES.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`rounded-full transition-all duration-300 ${i === current ? "w-6 h-2 bg-gold" : "w-2 h-2 bg-white/40"
              }`}
            aria-label={`Imagen ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
